import React, { useContext, useEffect, useState } from "react";
import { controller, endpoints } from "../../../api/actions/api";
import * as actions from "../../../api/actions/actions";
import { connect } from "react-redux";
import { AppContext } from "../../../App";
import RepNav from "./RepNav";
import { Table } from "../../../layout";
import moment from "moment";

const tblHeader = () => (
  <div className="d-flex a-center flex-wrap">
    <h2 className="border-left h fw-4 fs-16 gray-color tx-upp">
      Owner Contact Info
    </h2>
  </div>
);

const OwnerContact = (props) => {
  const { _getById, _hoa } = props;
  const { setLoader } = useContext(AppContext);
  const [csvHeader, setCsvHeader] = useState([]);
  const [tblData, setTblData] = useState([]);
  const [units, setUnits] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [sortDate, setSortDate] = useState({
    fromDate: `1/1/${new Date().getFullYear()}`,
    toDate: `12/31/${new Date().getFullYear()}`,
  });

  useEffect(() => {
    setCsvHeader([
      { label: "Unit", key: "unitName" },
      { label: "Unit Address", key: "unitAdd" },
      { label: "Owner", key: "ownerName" },
      { label: "Email", key: "email" },
      { label: "Phone", key: "phone" },
      { label: "Address", key: "address" },
      { label: "City", key: "city" },
      { label: "State", key: "state" },
      { label: "ZIP", key: "zip" },
    ]);
    return () => {
      setCsvHeader([]);
    };
  }, []);

  useEffect(() => {
    setTblData([
      ...filteredData.map((j) => {
        var owner = j.unitOwners[0] && j.unitOwners[0].owner;
        return {
          ...j,
          unitName: j.title,
          unitAdd: `${j.address1} | ${j.address2}`,
          ownerName: owner && owner.fullName,
          email: owner && owner.email,
          phone: owner && owner.phone,
          address: owner && `${owner.address1} | ${owner.address2}`,
          city: owner && owner.city,
          state: owner && owner.state,
          zip: owner && owner.zip,
        };
      }),
    ]);
    return () => {
      setTblData([]);
    };
  }, [filteredData]);

  useEffect(() => {
    if (_hoa.id) {
      setLoader(true);
      const onComplete = (res) => {
        setLoader(false);
        if (res.status === 200) {
          setUnits(res.result);
          setFilteredData(res.result);
        }
      };
      _getById(endpoints.Unit + controller.GetByHoa, _hoa.id, null, onComplete);
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_hoa]);

  useEffect(() => {
    units &&
      setFilteredData([
        ...units.filter(
          (j) =>
            moment(j.createDate, "MM/DD/YYYY") >=
              moment(sortDate.fromDate, "MM/DD/YYYY") &&
            moment(j.createDate, "MM/DD/YYYY") <=
              moment(sortDate.toDate, "MM/DD/YYYY")
        ),
      ]);

    return () => {
      setFilteredData([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [units, sortDate]);

  return (
    <>
      <div className="mt-20 mb-10">
        <RepNav
          {...{
            csvHeader,
            csvData: tblData,
            sortDate,
            setSortDate,
            title: "Owner Contact Info",
            showTitle: false,
          }}
        />
      </div>
      <div>
        <Table
          shadow={false}
          ActionComp={() => <></>}
          HeaderComp={tblHeader}
          tblHead={[
            { id: "unitName", label: "Unit Name" },
            { id: "unitAdd", label: "Unit Address" },
            { id: "ownerName", label: "Owner" },
            { id: "email", label: "Email" },
            { id: "phone", label: "Phone" },
            { id: "address", label: "Address" },
            { id: "city", label: "City" },
            { id: "state", label: "State" },
            { id: "zip", label: "ZIP" },
          ]}
          tblData={tblData}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  _hoa: state.storeData.defHoa,
});

const mapActionToProps = {
  _getById: actions.getById,
  _delete: actions.Delete,
};

export default connect(mapStateToProps, mapActionToProps)(OwnerContact);
